import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { getUiVersion } from '../utils';
import { brand } from '../theme/brand';

const Copyright = () => {
  return (
    <>
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © '} {new Date().getFullYear()}{' '}
        <Link color="inherit" href={brand.copyrightUrl}>
          {brand.appName}
        </Link>{' '}
        {getUiVersion()}
      </Typography>
    </>
  );
};

export default Copyright;
